import { useRouter } from 'next/router';

import { AuthBtn } from '@playbooks/components/auth/auth-btn';

import { useStore } from 'contexts';
import { useAction } from 'hooks';

const TemplateRemixBtn = ({ template, variant, rootApi, ...props }) => {
	const router = useRouter();
	const store = useStore();

	const [onClick, clickTask] = useAction(async () => {
		const response = await store.createRecord({ url: `${rootApi}/remix`, data: {} });
		router.push(response.data.appPath || response.data.webPath);
	});

	return (
		<AuthBtn prevIcon='cube' variant={variant} taskRunning={clickTask.running} onClick={onClick} {...props}>
			Remix
		</AuthBtn>
	);
};

export { TemplateRemixBtn };
